module.exports = __webpack_public_path__ + "static/media/girl-4.47c887fa.svg";